import React from 'react';
import Header from './Header';
import Footer from './Footer';
import { useLocation } from 'react-router';

const Layout = ({ children }) => {
  const useQuery = () => new URLSearchParams(useLocation().search);
  const query = useQuery();
  const idUrl = query.get('share');

  if (idUrl) {
    return children;
  }

  return (
    <div
      style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}
    >
      <Header />
      <div style={{ flex: 1 }}>{children}</div>
      <Footer />
    </div>
  );
};

export default Layout;
